import { render, staticRenderFns } from "./log_acesso.vue?vue&type=template&id=e06fb146&"
import script from "./log_acesso.vue?vue&type=script&lang=js&"
export * from "./log_acesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports